import React, {useRef, useEffect} from "react";
import ProfileName from "./ProfileName";
import LinkBar from "./LinkBar";
import Artboard from "./Artboard";
import About from "./About";
import {motion, useInView, useAnimation} from 'framer-motion';
import { useTransform, useScroll } from "framer-motion";

const Profile = ({ containerRef }) => {

  const profileContainerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: profileContainerRef,
    offset: ["start start", "end start"],
  });


  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.5]);
  const borderRadius = useTransform(scrollYProgress, [0, 1], ["0rem", "10rem"]);
  const width = useTransform(scrollYProgress, [0, 0.5], ["50%", "60%"]); 
  const height = useTransform(scrollYProgress, [0, 0.5], ["50vh", "100vh"]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.2 }}
      className="profile mx-auto flex items-center justify-center h-screen lg:pt-0 pt-32 "
    >
      <motion.div
        ref={profileContainerRef}
        className=""
        style={{
          // width,
          // height,
          borderRadius,
          scale
        }}
      >
        <Artboard>
          <div className="h-fit flex items-center w-full p-1 flex-col lg:flex-row">
            <div className="grid flex-grow rounded-box place-items-center">
              <ProfileName />
            </div>
            <div className="divider lg:divider-horizontal"></div>
            <div className="grid flex-grow rounded-box place-items-center">
              <About />
            </div>
          </div>
          <LinkBar />
        </Artboard>
      </motion.div>
    </motion.div>
  );
};

export default Profile;
